//
//
//
//
//
//
//
//
//
//

import banner from '@/assets/pufaxuanchuan/banner.png'
import { getview } from '@/api/jfhl.js'
export default {
  components: {},
  data () {
    return {
      partyid: this.$route.params.partyid,
      banner: banner,
      explist: []
    }
  },
  watch: {},
  mounted () {
    this.view()
  },
  methods: {
    // 获取问卷id
    view () {
      getview({
        id: this.partyid
      }).then(res => {
        this.explist = res.obj.explist
      })
    }
  },
  created () {}
}
